import IdentitiesMetrics from '../IdentitiesMetrics';
import ModuleCarousel from '../ModuleCarousel';
import { IntegrationsList } from './IntegrationsList';
import { useDashboardContext } from '../DashboardContext';

export const Main = () => {
    const { showLoader } = useDashboardContext();

    return (
        <>
            {showLoader && (
                <div className="silverfort-loader">
                    <div className="logo"></div>
                </div>
            )}
            <div className="flex justify-between grow max-h-full relative pr-[21.9vw] overflow-hidden">
                <IdentitiesMetrics />
                <ModuleCarousel />
                <aside className="absolute top-0 bottom-0 right-0 w-[21.9vw] flex items-center justify-center">
                    <IntegrationsList />
                </aside>
            </div>
        </>
    );
};
